import SimpleStore from '../../utils/simpleStore';
export var TEAM_ACCOUNT_COOKIE = 'ddfw_team_account';
export var getDefaultTeamAccountIdFromCookie = function () {
    var teamAccountId = SimpleStore.get(TEAM_ACCOUNT_COOKIE) || null;
    return teamAccountId || '';
};
export var setDefaultTeamAccountIdToCookie = function (teamAccountId) {
    // save new cookie
    SimpleStore.set(TEAM_ACCOUNT_COOKIE, teamAccountId);
};
